module.exports = __webpack_public_path__ + "static/media/Z.fb77bc00.jpg";